
define('text!modules/creatives/bulkedit/templates/review_body.html',[],function () { return '<div class="form-stack">\n\t<dt class="entityType">{{entityType}}s <span>({{entityCount}})</span></dt>\n\t<div class="entity-grid"></div>\n</div>\n<div class="form-stack">\n\t<dt class="changes">Changes <span>({{changeCount}})</span></dt>\n\t<div class="change-grid"></div>\n</div>';});

